import React, { useEffect } from 'react';
import { makeAPICall } from '../../core/services/http-request';
import { useSelector, useDispatch } from 'react-redux';
import { setActiveConsulta } from '../../core/consultaDinamica/consultaDinamica-actions';
import { useLocation } from 'react-router-dom';
import { ConsultaDinamica } from '@intervan-ar/ov-views';

const ConsultaDinamicaWrapper = (props) => {
  const { headerProps } = props;
  const dispatch = useDispatch();
  const consultaIndex = useSelector(state => {
    return state?.consultasDinamicas?.activa;
  });
  const consulta = useSelector(state => {
    if(consultaIndex >= 0)
      return state?.consultasDinamicas.consultas[consultaIndex] ?? undefined;
    return undefined;
  });
  const location = useLocation();

  return (
    <ConsultaDinamica
    headerProps={headerProps}
    consulta={consulta}
    fetchFunction={makeAPICall}
    location={location}
    dispatch={dispatch}
    setActiveConsulta={setActiveConsulta}
    />
  );
};

export default ConsultaDinamicaWrapper;
